import { Checkbox } from "./Checkbox";
import { Country } from "./Country/index";
import { Email } from "./Email";
import { Message } from "./Message";
import { Number } from "./Number";
import { Select } from "./Select";
import { State } from "./State/index";
import { Text } from "./Text";
import { Textarea } from "./Textarea";

export const fields = {
  checkbox: Checkbox,
  country: Country,
  email: Email,
  message: Message,
  number: Number,
  select: Select,
  state: State,
  text: Text,
  textarea: Textarea,
};
